import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDividerBlank20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDividerBlank20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.406 3.675c0-.69.56-1.25 1.25-1.25h8.688c.69 0 1.25.56 1.25 1.25v2.95a.75.75 0 1 0 1.5 0v-2.95a2.75 2.75 0 0 0-2.75-2.75H5.656a2.75 2.75 0 0 0-2.75 2.75v2.95a.75.75 0 1 0 1.5 0zm0 12.65c0 .69.56 1.25 1.25 1.25h8.688c.69 0 1.25-.56 1.25-1.25v-2.95a.75.75 0 1 1 1.5 0v2.95a2.75 2.75 0 0 1-2.75 2.75H5.656a2.75 2.75 0 0 1-2.75-2.75v-2.95a.75.75 0 0 1 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDividerBlank20);
